"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userResumeApi = userResumeApi;
exports.userResumeBulkOrderApi = userResumeBulkOrderApi;
exports.userResumeDelApi = userResumeDelApi;
exports.userResumeEditApi = userResumeEditApi;
exports.userResumeExportApi = userResumeExportApi;
exports.userResumeListApi = userResumeListApi;
exports.userResumeRefreshApi = userResumeRefreshApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// 列表 履历
function userResumeListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/batchPreOrder/list',
    method: 'get',
    params: params
  });
}

// 编辑 履历
function userResumeEditApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/batchPreOrder/edit',
    method: 'post',
    data: data
  });
}

// 删除 履历
function userResumeDelApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/batchPreOrder/delete',
    method: 'post',
    data: data
  });
}

// 导入 履历
function userResumeApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/batchPreOrder/import',
    method: 'post',
    data: data
  });
}

// 批量下单
function userResumeBulkOrderApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/batchPreOrder/processOrder',
    method: 'post',
    data: data
  });
}

// 刷新订单状态
function userResumeRefreshApi() {
  return (0, _request.default)({
    url: '/admin/platform/batchPreOrder/refresh',
    method: 'post'
  });
}

// 导出 履历
function userResumeExportApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/batchPreOrder/export',
    method: 'post',
    data: data
  });
}